const Font = 'Helvetica';
const tableWidth = 750;
const cellWidth = tableWidth / 11 - 28;
export default {
  container: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  containerMobile: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  DivSearch: {
    display: 'flex',
  },

  DivSearchMobile: {
    display: 'flex',
    justifyContent: 'center',
  },
  optionText: {
    fontFamily: Font,
    FontSize: '14px',
    paddingLeft: '38px',
    margin: '3px',
  },

  calenderStyle: {
    backgroundColor: '#13639c',
    color: 'white',
    fontWeight: 'bold',
    top: '0px',
    textAlign: 'center',
    padding: 3,
    fontSize: '14px',
  },
  calendar: {
    backgroundColor: '#13639c',
    color: 'white',
    fontWeight: 'bold',
    top: '0px',
    textAlign: 'center',
    padding: 3,
    fontSize: '14px',
  },
  calenderStyleMobile: {
    backgroundColor: '#13639c',
    color: 'white',
    fontWeight: 'bold',
    top: '0px',
    textAlign: 'center',
    padding: 0,
    fontSize: '12px',
  },
  optionStyleMobile: {
    top: '0px',
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: '#043659',
    textAlign: 'center',
    padding: 0,
    borderLeft: '1px solid',
    fontSize: '12px',
  },

  optionStyle: {
    top: '0px',
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: '#043659',
    textAlign: 'center',
    padding: 3,
    borderLeft: '1px solid',
    fontSize: '14px',
  },

  optionTextMobile: {
    fontFamily: Font,
    FontSize: '14px',
    paddingLeft: '16px',
    margin: '3px',
  },
  StockWatchoptionText: {
    fontFamily: Font,
    FontSize: '14px',
    paddingLeft: '38px',
    paddingTop: '6px',
  },
  StockWatchoptionTextMobile: {
    fontFamily: Font,
    FontSize: '14px',
    paddingTop: '4px',
  },

  option: {
    display: 'flex',
  },
  delButton: {
    height: '20px',
    marginTop: '2px',
    marginLeft: '10px',
    width: '20px',
  },
  ContainerContent: {
    padding: '30px 0',
  },
  tableDivText: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    height: '25px',
  },
  FavDiv: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    height: '25px',
    marginTop: '30px',
  },
  warningRightSide: {},
  warningText: {
    color: 'rgb(57, 58, 59)',
    fontFamily: Font,
    marginRight: 20,
    fontSize: '0.875rem',
  },
  warningPaper: {
    boxShadow: 'none',
    backgroundColor: 'rgba(241,241,242,255)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: 'auto',
    padding: 25,
    border: '1px solid',
    borderRadius: '20px',
    position: 'relative',
    marginBottom: 10,
    width: '234px',
    fontSize: '0.875rem',
    marginTop: '40px',
  },
  FavDivTable: {
    display: 'flex',
    width: '80%',
    overflowY: 'scroll',
    maxHeight: '279px',
    margin: 'auto',
  },

  FavDivTableMobile: {
    display: 'flex',
    width: '80%',
    overflowY: 'scroll',
    maxHeight: '175px',
    margin: 'auto',
    marginTop: '20px',
    marginBottom: '20px',
  },
  tableDiv: {
    display: 'flex',
    margin: 'auto',
    overflowY: 'scroll',
    width: '94.1%',
    maxHeight: 800,
  },

  blackText: {
    backgroundColor: 'rgb(8, 65, 113)',
    fontSize: '14px',
    color: 'white',
    textAlign: 'center',
    width: '54%',
    paddingTop: '6px',
  },
  blackText2: {
    backgroundColor: 'rgb(8, 65, 113)',
    fontSize: '14px',
    color: 'white',
    textAlign: 'center',
    width: '40%',
    paddingTop: '6px',
  },

  TableContainer: {
    overflowY: 'scroll',
    margin: 'auto',
    width: '100%',
    maxHeight: 250,
  },

  TableHeaderCell: {
    background: 'rgb(101, 101, 102)',
    color: 'white',
    padding: 0,
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    zIndex: 5,
  },

  tableRow: {},

  modalTableRow: {
    lineHeight: '1',
    border: 'none',
    borderBottom: '1px solid grey',
    padding: '10px',
    fontSize: 12,
    textAlign: 'end',
  },

  modalTableRowFavouriteTable: {
    lineHeight: '0.1rem',
    borderStyle: 'solid',
    borderWidth: '1px',
    fontSize: 12,
    borderColor: '#C0C0C0',
    textAlign: 'center',
  },
  tableBody: {
    border: '1px solid',
  },
  tableBodySecond: {
    border: '1px solid',
    borderLeft: 'none',
  },
  rightSideMainDiv: {
    height: 'calc(100%)',
    paddingTop: '27px',
    paddingBottom: '30px',
    boxSizing: 'border-box',
    background: '#D3D3D3',
  },
  imageDiv: {
    margin: '0 auto',
    width: '90%',
  },
  imageStyle: {
    width: '100%',
    height: '320px',
  },
  tickerInput: {
    width: '140px',
    fontSize: 18,
    fontFamily: Font,
    color: 'gray',
    paddingLeft: '6px',
    textAlign: 'center',
    marginLeft: '5px',
    marginTop: '2px',
  },
  tickerInputSmall: {
    width: '140px',
    fontSize: 18,
    borderRadius: '5px',
    fontFamily: Font,
    color: 'gray',
    textAlign: 'center',
    marginLeft: '5px',
    marginTop: '2px',
  },
  tickerInputMobile: {
    width: '110px',
    fontSize: 14,
    borderRadius: '5px',
    fontFamily: Font,
    color: 'gray',
    textAlign: 'center',
  },
  goButton: {
    marginLeft: 10,
    width: '30px',
    minWidth: 30,
    maxWidth: 30,
    height: '30px',
    background: 'green',
    color: 'white',
  },
};



// WEBPACK FOOTER //
// ./src/Pages/WatchList/WatchListStyles.js